var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76667 5.25833L5 2.02499L8.23333 5.25833C8.55833 5.58333 9.08333 5.58333 9.40833 5.25833C9.73333 4.93333 9.73333 4.40833 9.40833 4.08333L5.58333 0.258325C5.25833 -0.0666752 4.73333 -0.0666752 4.40833 0.258325L0.583336 4.08333C0.258336 4.40833 0.258336 4.93333 0.583336 5.25833C0.908336 5.57499 1.44167 5.58333 1.76667 5.25833Z",
    fill: "#5C715E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron_up.6c7adb06c5c9838428873ff89feca95f.svg";
export { ForwardRef as ReactComponent };